import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/edit_inspection/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_templates/agro_exporter_process/${agro_exporter_process_id}/container/${container_id}`
    );
  },
  fetchExportedBatches({ container_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/edit_inspection/container/${container_id}/exported_batches`
    );
  },
  fetchTemplate({ container_id, quality_template_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/edit_inspection/container/${container_id}/quality_template/${quality_template_id}`
    );
  },
  fetchExportQualityInspect({
    container_id,
    quality_template_id,
    quality_inspect_id
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/edit_inspection/container/${container_id}/quality_template/${quality_template_id}/quality_inspect/${quality_inspect_id}`
    );
  },
  updateExportQualityInspect({
    quality_inspect_id,
    container_id,
    quality_template_id,
    registered_at,
    observations,
    exported_batch_id,
    samplings,
    quality_samplings
  }) {
    return RequesterV1.post(
      `/agro_exporter/quality_control/container/edit_inspection/container/${container_id}/quality_template/${quality_template_id}/update/${quality_inspect_id}`,
      {
        quality_inspect: {
          registered_at,
          samplings,
          observations
        },
        exported_batch_id,
        quality_samplings
      }
    );
  },
  updateWithoutSamplings({
    quality_inspect_id,
    container_id,
    quality_template_id,
    registered_at,
    observations,
    exported_batch_id,
    quality_generals
  }) {
    return RequesterV1.post(
      `/agro_exporter/quality_control/container/edit_inspection/container/${container_id}/quality_template/${quality_template_id}/update_without_samplings/${quality_inspect_id}`,
      {
        quality_inspect: {
          registered_at,
          observations
        },
        exported_batch_id,
        quality_generals
      }
    );
  }
};
